import { render, staticRenderFns } from "./holidayLegend.vue?vue&type=template&id=7c2334cb&"
import script from "./holidayLegend.vue?vue&type=script&lang=js&"
export * from "./holidayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports